import { render, staticRenderFns } from "./Bouton.vue?vue&type=template&id=0c5cb393&scoped=true&"
import script from "./Bouton.vue?vue&type=script&lang=js&"
export * from "./Bouton.vue?vue&type=script&lang=js&"
import style0 from "./Bouton.vue?vue&type=style&index=0&id=0c5cb393&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5cb393",
  null
  
)

export default component.exports